export default "__VITE_ASSET__CkBG4AQs__"